(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.accordion__divider-wrap').forEach(function (wrap) {
      window.applyDashedLine(wrap);
    });

    document.querySelectorAll('.accordion').forEach(function (details) {
      var summary = details.querySelector('.accordion__summary');
      var wrap = details.querySelector('.accordion__body-wrap');
      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (details.open) {
          details.classList.add('is-closing');
          wrap.addEventListener('transitionend', function () {
            details.removeAttribute('open');
            details.classList.remove('is-closing');
          }, { once: true });
        } else {
          details.open = true;
          details.classList.add('is-opening');
          details.offsetHeight;
          details.classList.remove('is-opening');
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
